function ProductDetail({label, value, unit}) {
    return(
        <div className="prod-detail">
            <div className="label">{label}</div>
            <div className="value">{value} {unit}</div>
        </div>
    )
}

export default ProductDetail;